'use strict';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const SELECTOR = '.js-animated-scroll';
const SLIDES = '.js-animated-slide';
const PIN = '.js-animated-pin';
const IMAGE = '.js-animated-image';
const IMAGECONTAINER = '.js-animated-image-container';
const BACKGROUND = '.js-animated-background';

export function init() {
	const elements = document.querySelectorAll(SELECTOR);

	if (!elements.length) {
		return false;
	}

	elements.forEach(element => {
		var slides = element.querySelectorAll(SLIDES);
		var pin = element.querySelector(PIN);
		var imageContainer = element.querySelector(IMAGECONTAINER);
		var background = element.querySelector(BACKGROUND);
		var scrollTriggers = [];
		var initializedDesktop = null;

		var lastSlide = Array.from(element.querySelectorAll(SLIDES)).pop(); // eslint-disable-line compat/compat

		element.addEventListener('theme:reset', function(){
			if (scrollTriggers.length) {
				for (var i in scrollTriggers) {
					scrollTriggers[i].kill(true);
				}
				scrollTriggers = [];
			}
		});

		element.addEventListener('theme:initialize', function(){

			if (window.innerWidth >= 1000) {
				if (initializedDesktop !== true) {
					element.dispatchEvent(new Event('theme:reset'));

					initializedDesktop = true;
					scrollTriggers.push(
						ScrollTrigger.create({
							trigger: pin,
							pin: pin,
							start: "center center",
							pinSpacing: false,
							endTrigger: lastSlide,
							end: "50% 50%",
							scrub: true
						})
					)
				}
			} else {
				if (initializedDesktop !== false) {
					initializedDesktop = false;
					element.dispatchEvent(new Event('theme:reset'));

					scrollTriggers.push(
						ScrollTrigger.create({
							trigger: pin,
							pin: pin,
							start: "top top",
							pinSpacing: false,
							endTrigger: lastSlide,
							end: "top top",
							scrub: true
						})
					)
				}
			}

			if (!background) {
				var slideImageID = document.querySelector(slides[0].dataset.image);

				scrollTriggers.push(
					ScrollTrigger.create({
						trigger: element,
						start: "top center",
						end: "100vh",
						onEnter:function() {
							slideImageID.classList.add('first');
						},
						onLeave:function() {
							slideImageID.classList.remove('first');
						},
						onEnterBack:function() {
							slideImageID.classList.add('first');
						},
						onLeaveBack:function() {
							slideImageID.classList.remove('first');
						}
					})
				);
			}

			slides.forEach(slide => {
				var slideImageID = document.querySelector(slide.dataset.image);
				var slideImage = slide.querySelector(IMAGE);

				if (slideImage) {
					imageContainer.appendChild(slideImage);
				}

				scrollTriggers.push(
					ScrollTrigger.create({
						trigger: slide,
						start: "top center",
						end: "bottom center",
						onEnter:function() {
							slide.classList.add('current');
							slideImageID.classList.add('active');
						},
						onLeave:function() {
							slide.classList.remove('current');
							slideImageID.classList.remove('active');
						},
						onEnterBack:function() {
							slide.classList.add('current');
							slideImageID.classList.add('active');
						},
						onLeaveBack:function() {
							slide.classList.remove('current');
							slideImageID.classList.remove('active');
						},
					})
				);
			});
		});

		element.dispatchEvent(new Event('theme:initialize'));

		window.addEventListener('resize', function(){
			setTimeout(function() {
				element.dispatchEvent(new Event('theme:initialize'));
			}, 100);
		});
	});

}
